import React, { useEffect, useState } from "react";

type Props = {
  src: string;
  style?: React.CSSProperties;
};

export const ResponsiveImage = ({ src, style }: Props) => {
  const fallbackSrc = `https://placehold.co/250x250.png?text=image%20not%20found`;
  const [source, setSource] = useState<string>(src || fallbackSrc);

  useEffect(() => setSource(src || fallbackSrc), [src, fallbackSrc]);

  return (
    // oxlint-disable-next-line nextjs/no-img-element
    <img
      src={source}
      onError={() => setSource(fallbackSrc)}
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        height: "auto",
        width: "auto",
        ...style,
      }}
    />
  );
};
